export default "__VITE_ASSET__2aafe767__"